/*
 * @Description: 文件内容
 * @Author: dali
 * @Date: 2021-03-27 14:49:38
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-09-20 14:31:17
 */
import HeadBar from '../head-bar'
import Footer from '../footer'
import { Fragment, Component } from 'react'
import styles from './home.scss'

import wrapWithUser from '@/components/wrapWithUser'
import PreOrderEx from '@/pages/pre-order-ex'
import { Outlet } from 'react-router-dom'
import Im from '@/components/im'
import ImCustomer from '@/components/im-customer'
class Home extends Component {
  render() {
    return (
      <Fragment>
        <HeadBar/>
        {/* 这里渲染子路由！！ */}
        <div className={styles['home']}>
          <Outlet />
        </div>
        {/* 这里渲染子路由！！ end */}
        <Im/>
        <ImCustomer/>
        <PreOrderEx/>
        <Footer/>
      </Fragment>
    )
  }
}
export default wrapWithUser(Home)
